// Phase 18 Plan 06 — POLISH-11 $contrast persistent atom.
//
// Toggled from Settings → Accessibility → High contrast segmented pill
// (ContrastToggle.tsx). RootApp mirrors the value onto
// documentElement.dataset.contrast so the single [data-contrast="high"] block
// in theme.css can override text/bg/surface-stroke/cta tokens to hit ≥7:1
// body-text contrast (UI-SPEC §Color High-contrast overrides). WS0b (ARCA-87)
// collapsed the former per-theme [data-theme="X"][data-contrast="high"] blocks.

import { persistentAtom } from '@nanostores/persistent'

export type Contrast = 'normal' | 'high'

export const CONTRASTS: ReadonlyArray<Contrast> = ['normal', 'high']
export const DEFAULT_CONTRAST: Contrast = 'normal'

export function isContrast(v: unknown): v is Contrast {
  return v === 'normal' || v === 'high'
}

export const $contrast = persistentAtom<Contrast>(
  'runegambit.contrast',
  DEFAULT_CONTRAST,
  {
    encode: (v) => v,
    decode: (s) => (isContrast(s) ? s : DEFAULT_CONTRAST),
  },
)
